export default __webpack_public_path__ + "static/media/element_spec_37.e62a2e34.webp";